import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Printers } from '../printers';

export const getPrintersState = createFeatureSelector<Printers>('printers');
export const getPrintersList = createSelector(
  getPrintersState,
  (state: Printers) => state.list,
);
export const getPrinters = createSelector(
  getPrintersState,
  (state: Printers) => state.list.data,
);

export const getAutoprintSubscriptions = createSelector(
  getPrintersState,
  (state: Printers) => state.autoprintState.subscriptions,
);
export const getAutoprintQueue = createSelector(
  getPrintersState,
  (state: Printers) => state?.autoprintState?.autoprintQueue,
);
export const getRecentlyPrintedOrders = createSelector(
  getPrintersState,
  // Defaulted: an app updated while the printers slice was already in memory,
  // and any spec that hands provideMockStore a hand-written autoprintState,
  // both arrive here without the field.
  (state: Printers) => state?.autoprintState?.recentlyPrintedOrders ?? [],
);
export const getAutoprintSubscriptionsByStoreId = createSelector(
  getPrintersState,
  (state: Printers, props) =>
    Object.prototype.hasOwnProperty.call(
      state.autoprintState.subscriptions,
      props.storeId,
    ),
);
